import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import PartnersCard from './_partners_card';

import { makeStyles } from '@material-ui/core/styles';
import { partners } from './__data';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(10),
  },
  paperTitle: {
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    paddingTop: '5rem',
    paddingBottom: '8rem'
  }
}));

const Partners = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        alignItems="center"
        className={classes.section}
        component="section"
        container
        direction="column"
        justify="center"
        xs={12}
      >
        <Paper
          className={classes.paperTitle}
          component="header"
        >
          <Typography
            align="center"
            component="h2"
            variant="h1"
          >
            Nos Partenaires
          </Typography>
          <Typography
            align="center"
            component="p"
            variant="body2"
          >
            Ils partagent l’aventure avec nous
          </Typography>
        </Paper>
        <Grid
          container
          justify="center"
          lg={6}
          md={7}
          sm={9}
          xs={12}
        >
          {partners.map((partner, index) => {
            return(
              <Grid
                component="article"
                item
                key={`partner-${index}`}
                md={3}
                sm={4}
                xs={5}
              >
                <PartnersCard partner={partner} />
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    </>
  );
}

export default Partners;
